<form [formGroup]="studyFormGroup" appScrollToInvalidControlOnSubmit class="o-grid">
    <div class="o-grid__row">
        <div class="o-grid__item third stepper-min-width">
            <medpace-vertical-stepper [steps]="steps"></medpace-vertical-stepper>
        </div>
        <div class="o-grid__item">
            <div class="o-grid">
                <div class="o-grid__row">
                    <div class="o-grid__card">
                        <div class="flex start middle">
                            <span class="required-asterisk">*</span>
                            <span class="note"> indicates a required field </span>
                        </div>
                    </div>
                    <ng-container *ngTemplateOutlet="submitButton"></ng-container>
                </div>

                <div class="o-grid__row" id="tierSupport">
                    <div class="o-grid__card">
                        <ng-content select="medpace-study-payment-approval-threshold-card" />
                    </div>
                </div>

                <div class="o-grid__row" name="" id="studyDetails">
                    <div class="o-grid__card">
                        <medpace-input-card
                            [inputObj]="study"
                            [showEditSaveButton]="isUpdate && isAdmin"
                            [editMode]="!isUpdate"
                            type="study-detail"
                            title="Study Details"
                            [parentFormGroup]="studyFormGroup"
                            (incrementalUpdate)="submitIncrementalSave()"
                            (inputChangeEvent)="processStudyChange($event)"
                        >
                        </medpace-input-card>
                    </div>
                </div>

                <div class="o-grid__row" id="studyInfo">
                    @if (isAdmin) {
                        <div class="o-grid__card" name="study-info">
                            <mds-expansion-panel
                                expansionFormErrorHighlighter
                                id="studyInfoExpansionPanel"
                                [panelTitle]="'Study Information'"
                                [description]="''"
                                icon="info"
                                [forms]="[getStudyInfoFormGroup()]"
                                [attr.data-cy]="'studyInfoExpansionPanel'"
                            >
                                <medpace-input-card
                                    [isCard]="false"
                                    [inputObj]="study?.studyInfo"
                                    [showEditSaveButton]="isUpdate"
                                    [editMode]="!isUpdate"
                                    type="study-info"
                                    [title]="studyInfoTitle"
                                    [parentFormGroup]="studyFormGroup"
                                    (incrementalUpdate)="submitIncrementalSave()"
                                    (inputChangeEvent)="processStudyChange($event)"
                                    [isModal]="true"
                                    [showTitle]="false"
                                >
                                </medpace-input-card>
                            </mds-expansion-panel>
                        </div>
                    } @else {
                        <div class="o-grid__item">
                            <medpace-input-card
                                [inputObj]="study?.studyInfo"
                                [showEditSaveButton]="false"
                                [editMode]="!isUpdate"
                                [parentFormGroup]="studyFormGroup"
                                [title]="studyInfoTitle"
                                type="study-info"
                            ></medpace-input-card>
                        </div>
                    }
                </div>
                <ng-container *ngTemplateOutlet="submitButton"></ng-container>
            </div>
        </div>
    </div>
</form>

<ng-template #submitButton>
    @if (study) {
        <div class="o-grid__card">
            <div class="flex flex-row end gap-medpace">
                @if (isUpdate) {
                    <mds-button
                        [id]="'submitStudy'"
                        [color]="'primary'"
                        [variant]="'filled'"
                        (clickEvent)="submit({ type: 'save', doRoute: true })"
                        [label]="label"
                        type="submit"
                    ></mds-button>
                } @else {
                    @if (this.studyClinTrakData()) {
                        @if (!isSubmitted()) {
                            <mds-button
                                [id]="'rejectStudy'"
                                [variant]="'tonal'"
                                [color]="'warn'"
                                (clickEvent)="reject()"
                                [label]="'Reject'"
                                [type]="'submit'"
                            />
                            <mds-button
                                [id]="'submitStudy'"
                                [variant]="'filled'"
                                (clickEvent)="submitClinTrakData({ type: 'save', doRoute: true })"
                                [label]="'Submit'"
                                [type]="'submit'"
                            />
                        } @else if (toApproved()) {
                            <mds-button
                                [id]="'approveStudy'"
                                [variant]="'filled'"
                                (clickEvent)="approveClinTrakData()"
                                [label]="'Approve'"
                                [type]="'submit'"
                                [disabled]="!canApprove()"
                                [matTooltip]="!canApprove() ? 'Approve is not available for submitter' : ''"
                            />
                        }
                    } @else {
                        <mds-button [variant]="'filled'" [label]="'Loading...'" [isLoading]="true" />
                    }
                }
            </div>
        </div>
    }
</ng-template>
